import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _600cb324 = () => interopDefault(import('../pages/enquiry-form/index.vue' /* webpackChunkName: "pages/enquiry-form/index" */))
const _7038a1f2 = () => interopDefault(import('../pages/modules/index.vue' /* webpackChunkName: "pages/modules/index" */))
const _396da27c = () => interopDefault(import('../pages/modules/blog_listing.vue' /* webpackChunkName: "pages/modules/blog_listing" */))
const _fb5ecd84 = () => interopDefault(import('../pages/modules/co_working_listing.vue' /* webpackChunkName: "pages/modules/co_working_listing" */))
const _181b9350 = () => interopDefault(import('../pages/modules/private_hire_listing.vue' /* webpackChunkName: "pages/modules/private_hire_listing" */))
const _4971201c = () => interopDefault(import('../pages/modules/rooms_listing.vue' /* webpackChunkName: "pages/modules/rooms_listing" */))
const _14cee434 = () => interopDefault(import('../pages/modules/rooms_pricing.vue' /* webpackChunkName: "pages/modules/rooms_pricing" */))
const _59957200 = () => interopDefault(import('../pages/modules/_module.vue' /* webpackChunkName: "pages/modules/_module" */))
const _241f6f8e = () => interopDefault(import('../pages/book/_type/_location/index.vue' /* webpackChunkName: "pages/book/_type/_location/index" */))
const _74f7348f = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _68bc581c = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/enquiry-form",
    component: _600cb324,
    name: "enquiry-form"
  }, {
    path: "/modules",
    component: _7038a1f2,
    name: "modules"
  }, {
    path: "/modules/blog_listing",
    component: _396da27c,
    name: "modules-blog_listing"
  }, {
    path: "/modules/co_working_listing",
    component: _fb5ecd84,
    name: "modules-co_working_listing"
  }, {
    path: "/modules/private_hire_listing",
    component: _181b9350,
    name: "modules-private_hire_listing"
  }, {
    path: "/modules/rooms_listing",
    component: _4971201c,
    name: "modules-rooms_listing"
  }, {
    path: "/modules/rooms_pricing",
    component: _14cee434,
    name: "modules-rooms_pricing"
  }, {
    path: "/modules/:module",
    component: _59957200,
    name: "modules-module"
  }, {
    path: "/book/:type?/:location",
    component: _241f6f8e,
    name: "book-type-location"
  }, {
    path: "/",
    component: _74f7348f,
    name: "index"
  }, {
    path: "/*",
    component: _68bc581c,
    name: "all"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
